import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { iconSet } from '../../constants';
import { ProductSelectorService } from '../../services';
import { Subscription } from 'rxjs';
import { EshavaControlOptionItem } from 'eshava-controls';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'lib-product-selector',
    templateUrl: './product-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-selector.component.scss',
    imports: [SvgIconComponent, TranslatePipe]
})
export class ProductSelectorComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();

  public iconSet = iconSet
  public products: EshavaControlOptionItem[] = [];
  public selectedProduct: EshavaControlOptionItem | undefined;

  constructor(
    private _productSelectorService: ProductSelectorService
  ) {

  }

  public ngOnInit(): void {
    this._subscriptions.add(
      this._productSelectorService.productsRegistered$.subscribe(products => {
        this.products = products;
        this.checkSelectedProduct();
      })
    );

    this.products = this._productSelectorService.products
    this.checkSelectedProduct();
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public onProductSelected(productId: number): void {
    this.setProduct(productId, true);
  }

  private checkSelectedProduct(): void {
    if (this.products.length == 0) {
      return;
    }

    var selectedProductId = parseInt(localStorage.getItem('selectedProductId') || '0');
    if (!selectedProductId) {
      return;
    }

    this.setProduct(selectedProductId, false);
  }

  public setProduct(productId: number, toStorage: boolean): void {
    var selectedProduct = this.products.find(p => p.value === productId);

    if (!!selectedProduct) {
      if (toStorage) {
        localStorage.setItem('selectedProductId', productId.toString());
      }

      this.selectedProduct = selectedProduct;
      this._productSelectorService.onProductSelected(this.selectedProduct.value);
    } else {
      this.selectedProduct = undefined;
      this._productSelectorService.onProductSelected(undefined);
      localStorage.removeItem('selectedProductId');
    }
  }
}
